import { TContent } from '@_entities/content';

// @TODO: API에서 무조건 title이 돌아오는지 확인하기
export function extractTitle(data: TContent) {
	if (data.title) return data.title.original ?? data.title;
	if (data.content) return data.content;
	return data.URL;
}
